"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popularExerciseTemplateIds = exports.getExerciseMatches = void 0;
const utils_1 = require("./utils");
const lodash_1 = require("lodash");
const getExerciseMatches = ({ exercises, muscleGroupFilter, equipmentType, searchText, language, }) => {
    let result = exercises;
    result = filterExercisesWithMuscleGroup(muscleGroupFilter, result);
    result = filterExercisesWithEquipment(equipmentType, result);
    const normalizedSearchText = normalizeSearchText(searchText, language);
    let matches = filterExercisesWithSearchText(normalizedSearchText, result, language);
    matches = orderExercisesWithSearchText(normalizedSearchText, matches);
    return matches;
};
exports.getExerciseMatches = getExerciseMatches;
const filterExercisesWithMuscleGroup = (muscleGroup, exercises) => {
    if (muscleGroup === 'all_muscles') {
        return exercises;
    }
    return exercises.filter((rd) => rd.muscle_group === muscleGroup);
};
const filterExercisesWithEquipment = (equipmentType, exercises) => {
    if (equipmentType === 'all_equipment') {
        return exercises;
    }
    return exercises.filter((rd) => rd.equipment_category === equipmentType);
};
// Old filter exercise functionality, will be removed when new feature goes live
const filterExercisesWithSearchText = (searchText, exercises, language) => {
    if (searchText.length === 0) {
        return exercises.map((e) => ({ exercise: e, matchType: 'other' }));
    }
    const matches = [];
    for (const e of exercises) {
        const searchableSearchText = searchable(searchText);
        const searchableEnglishTitle = searchable(e.title);
        const searchableLocalizedTitleMap = !e.is_custom
            ? {
                en: searchable(e.title),
                es: e.es_title ? searchable(e.es_title) : undefined,
                de: e.de_title ? searchable(e.de_title) : undefined,
                fr: e.fr_title ? searchable(e.fr_title) : undefined,
                it: e.it_title ? searchable(e.it_title) : undefined,
                pt_PT: e.pt_title ? searchable(e.pt_title) : undefined,
                tr: e.tr_title ? searchable(e.tr_title) : undefined,
                zh_CN: e.zh_cn_title ? searchable(e.zh_cn_title) : undefined,
                zh_TW: e.zh_tw_title ? searchable(e.zh_tw_title) : undefined,
                ru: e.ru_title ? searchable(e.ru_title) : undefined,
                ja: e.ja_title ? searchable(e.ja_title) : undefined,
                ko: e.ko_title ? searchable(e.ko_title) : undefined,
                ar: e.ar_title ? searchable(e.ar_title) : undefined,
                ca: e.ca_title ? searchable(e.ca_title) : undefined,
                hi: e.hi_title ? searchable(e.hi_title) : undefined,
                pl: e.pl_title ? searchable(e.pl_title) : undefined,
                pt_BR: e.pt_br_title ? searchable(e.pt_br_title) : undefined,
            }
            : {
                en: searchable(e.title),
            };
        const searchableLocalizedTitle = searchableLocalizedTitleMap[language] || searchableLocalizedTitleMap.en;
        const searchableLocalizedMuscleGroupName = searchable(e.localized_muscle_group_name);
        const searchableMuscleGroup = searchable(e.muscle_group);
        const searchableMisspelledDumbbellEquipment = e.equipment_category === 'dumbbell' ? 'dumbell' : '';
        const searchableTags = !e.is_custom && e.manual_tag ? searchable(e.manual_tag) : '';
        const searchableAka = !e.is_custom && e.aka ? searchable(e.aka) : '';
        if (searchableLocalizedTitle.includes(searchableSearchText) ||
            searchableEnglishTitle.includes(searchableSearchText)) {
            matches.push({ exercise: e, matchType: 'title' });
            continue;
        }
        else if (searchableLocalizedMuscleGroupName.includes(searchableSearchText) ||
            searchableMuscleGroup.includes(searchableSearchText)) {
            matches.push({ exercise: e, matchType: 'muscle_group' });
            continue;
        }
        if (e.is_custom && 'custom'.includes(searchableSearchText)) {
            matches.push({ exercise: e, matchType: 'custom' });
            continue;
        }
        const splitSearch = searchableSearchText.split(' ');
        const splitTitle = [
            searchableLocalizedTitle,
            searchableEnglishTitle,
            searchableTags,
            searchableAka,
            searchableMisspelledDumbbellEquipment,
        ]
            .join(' ')
            .split(' ');
        // Find:
        // title ['arnold', 'press', '(barbell)']
        // search ['press', 'bar']
        if ((0, lodash_1.intersectionWith)(splitSearch, splitTitle, (search, title) => title.includes(search)).length === splitSearch.length) {
            matches.push({ exercise: e, matchType: 'other' });
            continue;
        }
    }
    return matches;
};
const orderExercisesWithSearchText = (searchText, exerciseMatches) => {
    if (searchText.length === 0) {
        return exerciseMatches;
    }
    return exerciseMatches
        .reduce((accu, currentMatch) => {
        const lowercaseTitle = currentMatch.exercise.title.toLowerCase();
        if (lowercaseTitle.startsWith(searchText)) {
            accu.push({
                exercise: currentMatch,
                weight: currentMatch.exercise.priority * 2,
            });
            return accu;
        }
        accu.push({
            exercise: currentMatch,
            weight: currentMatch.exercise.priority,
        });
        return accu;
    }, [])
        .sort((a, b) => b.weight - a.weight)
        .map((a) => a.exercise);
};
/**
 * trims, lowercases and removes trailing "s" character to
 * simplify english searches
 */
const normalizeSearchText = (searchText, language) => {
    const searchableSearchText = searchable(searchText).replace('-', ' ').trim();
    if (language !== 'en')
        return searchableSearchText;
    if (searchableSearchText.length < 3)
        return searchableSearchText;
    const lastCharacter = searchableSearchText.slice(-1);
    if (lastCharacter !== 's')
        return searchableSearchText;
    return searchableSearchText.slice(0, -1);
};
const searchable = (str) => {
    return (0, utils_1.removeAccents)(str.toLowerCase());
};
/**
 * Exercise templates that are shown at the top of the Exercise Library to
 * users who don't have any workouts logged.
 */
exports.popularExerciseTemplateIds = [
    'B8127AD1', // Lying Leg Curl (Machine)"
    '11A123F3', // Seated Leg Curl (Machine)"
    'D04AC939', // Squat (Barbell)"
    '75A4F6C4', // Leg Extension (Machine)"
    '422B08F1', // Lateral Raise (Dumbbell)"
    'C7973E0E', // Leg Press (Machine)"
    '07B38369', // Incline Bench Press (Dumbbell)"
    '3601968B', // Bench Press (Dumbbell)"
    '6A6C31A5', // Lat Pulldown (Cable)"
    '0393F233', // Seated Cable Row - V Grip (Cable)"
    '37FCC2BB', // Bicep Curl (Dumbbell)"
    '55E6546F', // Bent Over Row (Barbell)"
    '94B7239B', // Triceps Rope Pushdown"
    'C6272009', // Deadlift (Barbell)"
    '878CD1D0', // Shoulder Press (Dumbbell)"
    '651F844C', // Cable Fly Crossovers"
    '79D0BB3A', // Bench Press (Barbell)"
    '93A552C6', // Triceps Pushdown"
    '7E3BC8B6', // Hammer Curl (Dumbbell)"
    'BE640BA0', // Face Pull
];
